import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">热度榜单</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">实时更新最受欢迎影视内容排行</p>
        <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={item.rank}
              href="#ranking"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-primary-50/50 transition-colors duration-150 cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-heading text-sm flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm md:text-base font-medium text-foreground-800 truncate">{item.title}</div>
                <div className="text-xs text-foreground-400 mt-0.5">{item.channel}</div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-accent-600 font-medium whitespace-nowrap">{item.heat}</span>
                <span className={`text-xs ${item.trend === 'up' ? 'text-primary-500' : 'text-secondary-500'}`}>
                  <i className={`text-sm ${item.trend === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'}`}></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}